import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import DashboardGerencialWidget from './DashboardGerencialWidget';
import { drawerWidth } from 'store/constant';
import LogoSection from '../LogoSection';

// ==============================|| SIDEBAR DRAWER ||============================== //

const getUserData = () => {
  const userData = localStorage.getItem('hotelData');
  return userData ? JSON.parse(userData) : null;
};

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const userData = getUserData();
  let showDashboardWidget = false;
  if (userData) {
    if (userData.role === 'admin' || userData.role === 'HotelAdmin') {
      showDashboardWidget = true;
    } else {
      showDashboardWidget = userData.permissions && userData.permissions.includes('Dashboard Gerencial');
    }
  }

  const drawer = (
    <>
      <Box sx={{ display: { xs: 'block', md: 'none' }, justifyContent: 'center', alignItems: 'center', margin: '10px 16px' }}>
        <LogoSection />
      </Box>
      <BrowserView>
        <PerfectScrollbar
          component="div"
          style={{
            height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 88px)',
            paddingLeft: '16px',
            paddingRight: '16px'
          }}
        >
          {showDashboardWidget && <DashboardGerencialWidget />}
          <MenuList />
        </PerfectScrollbar>
      </BrowserView>
      <MobileView>
        <Box sx={{ px: 2 }}>
          {showDashboardWidget && <DashboardGerencialWidget />}
          <MenuList />
        </Box>
      </MobileView>
    </>
  );

  const container = window !== undefined ? () => window.document.body : undefined;

  return (
    <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="mailbox folders">
      <Drawer
        container={container}
        variant={matchUpMd ? 'persistent' : 'temporary'}
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        sx={{
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
            borderRight: 'none',
            [theme.breakpoints.up('md')]: {
              top: '88px'
            }
          }
        }}
        ModalProps={{ keepMounted: true }}
        color="inherit"
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object
};

export default Sidebar;
